const api_platform = "https://enterprise-apis.ignif.ai/platform";

export { api_platform };
